import type { PaletteMode } from "@mui/material";
import { create } from "zustand";

type ThemeState = {
    mode: PaletteMode;
    toggleMode: () => void;
};

export const useThemeStore = create<ThemeState>((set) => ({
    mode: "light",
    toggleMode: () => set((state) => ({ mode: state.mode === "light" ? "dark" : "light" })),
}));
